/**
 * The Signature Jaw Massage — wellness page content.
 * Copy is written and fact-checked by the Waterloo reframe pipeline
 * (./generated/pages.json → massage.wellness); prices, imagery and the
 * approved client reviews live here.
 */
import pages from './generated/pages.json';

const w = pages.massage.wellness;

export const massageCopy = pages.massage;

export const wellnessMassageData = {
  hero: {
    ...w.hero,
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=1600&q=80',
  },
  designedBy: w.designedBy,
  benefits: w.benefits,
  experience: w.experience,
  standards: w.standards,
  testimonials: [
    { quote: 'Genuinely the best massage I have had in London. I dreamt about it for a week afterwards.', author: 'Sarah J.', meta: 'Self-paid client' },
    { quote: 'I booked for the jaw tension. I now book monthly for the way I feel for three days afterwards.', author: 'Daniel R.', meta: 'Regular client' },
    { quote: 'Honestly the most relaxing hour of my month. My jaw felt lighter for days afterwards.', author: 'Sophie', meta: 'Regular client' },
  ],
  pricing: {
    headline: w.pricing.headline,
    cards: [
      { name: '60-minute Signature Jaw Massage', price: '£95', body: w.pricing.cardBodies[0], highlight: false },
      { name: '90-minute Signature Jaw Massage', price: '£135', body: w.pricing.cardBodies[1], highlight: true },
      { name: 'Course of 5 Signature Sessions', price: '£425', body: w.pricing.cardBodies[2], highlight: false },
    ],
    note: 'Subscriptions: weekly £85, fortnightly £90 or monthly £95 per 60-minute session. Gift vouchers available.',
  },
  faqs: w.faqs,
  finalCta: w.finalCta,
  seo: w.seo,
  disclaimer: pages.massage.landing.footer,
};
